import React from 'react'
import { render } from 'react-dom'

import Root from 'app/Root'
import { history, persistor, store } from './store'
import initialize from './initialize'
;(function() {
  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined }
    var evt = document.createEvent('CustomEvent')
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
    return evt
  }

  CustomEvent.prototype = window.Event.prototype

  window.CustomEvent = CustomEvent
})()

/* Element.closest polyfill for IE */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
}
if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this

    do {
      if (el.matches(s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}

/* SVGElement.contains polyfill for IE */
if (window.SVGElement && !SVGElement.prototype.contains) {
  SVGElement.prototype.contains = function(node) {
    if (!(0 in arguments)) {
      throw new TypeError('1 argument is required')
    }
    do {
      if (this === node) {
        return true
      }
      node = node && node.parentNode
    } while (node)
    return false
  }
}

/**
 * Loading:
 * 1. Google Analytics
 * 2. Fresh Desk
 * 3. Mixpanel ??? TODO: remove, no need it any more
 * 4. Sentry Raven
 * 5. Service worker
 */
initialize()

const docRoot = document.getElementById('docroot')

render(<Root store={store} history={history} persistor={persistor} />, docRoot)
